import { render, staticRenderFns } from "./AddVideoWithFileUpload.vue?vue&type=template&id=2c1f4ce8&scoped=true&lang=pug&"
import script from "./AddVideoWithFileUpload.vue?vue&type=script&lang=js&"
export * from "./AddVideoWithFileUpload.vue?vue&type=script&lang=js&"
import style0 from "./AddVideoWithFileUpload.vue?vue&type=style&index=0&id=2c1f4ce8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c1f4ce8",
  null
  
)

export default component.exports